import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';

import TopNavigation from './components/TopNavigation';
import '../assets/sass/deliveryTypeLayout.scss';
import background from '../assets/img/bg/ipos_original.jpg';
import {hideLoading} from '../redux/actions/loadingActions';

function ErrorLayout({branchInfo, hideLoading, generalErrorTranslationKey, t}) {
  const {branchId} = useParams();

  useEffect(() => {
    setTimeout(() => {
      hideLoading();
    }, 1000);

  }, []);

  return (
    <div
      className={ 'delivery-type-layout' }
      style={ {
        backgroundImage: `url(${background})`
      } }
    >
      <header className="header delivery-type-header">
        <TopNavigation empty shorHeader />
      </header>

      <div className={ 'error-block' }>
        <div className={ 'error-content' }>
          {generalErrorTranslationKey && (
            <div>{t(generalErrorTranslationKey)}</div>
          )}
          {!generalErrorTranslationKey && (
            <div>Sorry, restaurant is not available</div>
          )}

        </div>
      </div>
      {/*<DeliveryTypeSwitcher/>*/}
      {/*<ShortFooter/>*/}
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    branchInfo,
    generalErrorTranslationKey
  } = state;

  return {
    branchInfo,
    generalErrorTranslationKey
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      hideLoading
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ErrorLayout));
